import { EMediaStreamTrackState } from './ITrack';

export const isTrackEmpty: (track: MediaStreamTrack) => boolean = (track) => {
  if (!track) {
    return true;
  }

  const { muted, enabled, readyState } = track;

  return muted || !enabled || readyState === EMediaStreamTrackState.ENDED;
};
